import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";
import Swal from "sweetalert2"; // Importa SweetAlert2
import { Helmet } from "react-helmet";
const initialState = {
  name: "",
  celular: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, celular, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const cleanValue = name === "celular" ? value.replace(/\D/g, "") : value; // elimina todo lo que no es número
    setState((prevState) => ({ ...prevState, [name]: cleanValue }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      name: name,
      celular: celular,
      email: email,
      message: message,
      to_name: "AirBox",
    };

    // Muestra un SweetAlert con un loader mientras se envía el mensaje
    Swal.fire({
      title: "Enviando...",
      text: "Por favor, espere mientras se envía su mensaje.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          Swal.fire({
            icon: "success",
            title: "Mensaje enviado",
            text: "Su mensaje ha sido enviado correctamente.",
          });
          clearState();
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Hubo un problema al enviar su mensaje. Inténtelo nuevamente.",
          });
          console.error("EmailJS Error:", error);
        }
      );
  };

  return (
    <div>
      {/*<div id="asesores" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Nuestros Asesores</h2>
          <p>"Encantados de poder ayudarte."</p>
        </div>
        <div id="row">
          {props?.data?.asesores
            ? props.data.asesores.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 asesores">
                  <div className="thumbnail">
                    {d.whatsapp ? (
                     <a
                        href={`https://wa.me/${d.whatsapp}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={d.img} alt={d.name} className="asesores-img" />
                     </a>
                    ) : (
                      <div className="blocked">
                        <img
                          src={d.img}
                          alt={d.name}
                          className="asesores-img blocked-img"
                        />
                        <div className="overlay">
                          <i className="fa fa-lock"></i>
                        </div>
                      </div>
                    )}
                    <div className="caption">
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
                    */}
      <div id="contact">
      <Helmet>
        <title>ABX Shipping - Contacto</title>
      </Helmet>
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Ponte en contacto</h2>
                <p>
                  Por favor, ingresa tu mensaje en el siguiente formulario y un
                  asesor se comunicará contigo a la brevedad
                </p>
              </div>
              <form name="sentMessage" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Nombres y Apellidos"
                        required
                        onChange={handleChange}
                        value={name}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="tel"
                        maxLength={20}
                        id="celular"
                        name="celular"
                        className="form-control"
                        placeholder="WhatsApp"
                        required
                        onChange={handleChange}
                        value={celular}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Correo electrónico"
                        required
                        onChange={handleChange}
                        value={email}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Mensaje"
                    required
                    onChange={handleChange}
                    value={message}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Enviar Mensaje
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contacto</h3>
              {/*<p>
                <span>
                  <i className="fa fa-map-marker"></i> Dirección
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
                    */}
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Celular
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Correo
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p style={{ fontSize: "13px", fontStyle: "italic" }}>
                Atendemos únicamente por WhatsApp y correo electrónico
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
